<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
/**
 * Halo "Notify me" (Bana haber ver) - Login gate
 * - Guest ise: uyar + login sayfasına yönlendir
 * - Login ise: hiçbir şeye karışma (Halo'nun mevcut akışı çalışsın)
 */
(function () {
  'use strict';

  // --- Ayarlar ---
  var SELECTOR_NOTIFY_BUTTON =
    'button[data-button-message="notifyMe"], button[id^="halo-btn-notify"]';

  var SELECTOR_EMAIL_INPUT = 'input[type="email"][name="contact[email]"]';

  // Login durumu tespit edilemezse (null) guest kabul edilsin mi?
  // En iyi pratik: TRUE bırakın ve theme.liquid'e yukarıdaki Liquid snippet'i ekleyin.
  var ASSUME_GUEST_WHEN_UNKNOWN = true;

  var WARNING_MESSAGE =
    'To receive stock updates (Notify me), you first need to log in. You are being redirected to the login page.';

  // (Opsiyonel) Kullanıcı email yazdıysa login dönüşü otomatik doldurmak için:
  var SS_EMAIL_KEY = 'halo_notify_email';
  var SS_TS_KEY = 'halo_notify_email_ts';

  function getRelativeReturnTo() {
    var path = window.location.pathname || '/';
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    return path + search + hash;
  }

  function getLoginUrl() {
    // 1) Theme.liquid ile global verildiyse bunu kullan (en temiz yol)
    if (
      typeof window.__HALO_STOREFRONT_LOGIN_URL__ === 'string' &&
      window.__HALO_STOREFRONT_LOGIN_URL__
    ) {
      return window.__HALO_STOREFRONT_LOGIN_URL__;
    }

    // 2) Fallback: Shopify customer accounts login + return_to
    return (
      '/customer_authentication/login?return_to=' +
      encodeURIComponent(getRelativeReturnTo())
    );
  }

  function showWarning(message) {
    // Tema özel bildirim sistemi varsa buraya bağlayabilirsiniz.
    // Aksi halde en garanti yöntem alert().
    if (window.halo && typeof window.halo.showMessage === 'function') {
      window.halo.showMessage(message, 'warning');
      return;
    }
    window.alert(message);
  }

  function detectLoggedIn() {
    // 1) En güvenilir: Liquid ile set edilen boolean
    if (typeof window.__HALO_CUSTOMER_LOGGED_IN__ === 'boolean') {
      return window.__HALO_CUSTOMER_LOGGED_IN__;
    }

    // 2) Bazı mağazalarda işe yarayan analytics ipuçları (her mağazada garanti değil)
    try {
      var cid =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.page &&
        ShopifyAnalytics.meta.page.customerId;
      if (cid) return true;
    } catch (e) {}

    try {
      var stCid = window.__st && window.__st.cid;
      if (stCid) return true;
    } catch (e) {}

    try {
      var uid =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.lib &&
        ShopifyAnalytics.lib.user &&
        ShopifyAnalytics.lib.user().id();
      if (uid) return true;
    } catch (e) {}

    // Tespit edilemedi
    return null;
  }

  function saveEmailForAfterLogin(clickedButton) {
    try {
      var scope =
        clickedButton.closest('form') ||
        clickedButton.closest('.form-field') ||
        document;

      var input = scope.querySelector(SELECTOR_EMAIL_INPUT);
      if (input && input.value) {
        sessionStorage.setItem(SS_EMAIL_KEY, input.value);
        sessionStorage.setItem(SS_TS_KEY, String(Date.now()));
      }
    } catch (e) {}
  }

  function restoreEmailIfPresent() {
    try {
      var email = sessionStorage.getItem(SS_EMAIL_KEY);
      if (!email) return;

      // 30 dk sonra temizle (opsiyonel)
      var ts = parseInt(sessionStorage.getItem(SS_TS_KEY) || '0', 10);
      if (ts && Date.now() - ts > 30 * 60 * 1000) {
        sessionStorage.removeItem(SS_EMAIL_KEY);
        sessionStorage.removeItem(SS_TS_KEY);
        return;
      }

      var input = document.querySelector(SELECTOR_EMAIL_INPUT);
      if (input && !input.value) {
        input.value = email;
      }
    } catch (e) {}
  }

  // Login’den geri dönünce emaili geri doldur (opsiyonel)
  restoreEmailIfPresent();

  function gateToLoginIfGuest(buttonEl, evt) {
    var loggedIn = detectLoggedIn();

    if (loggedIn === true) {
      // Login -> hiçbir şey yapma
      return;
    }

    if (loggedIn === null && !ASSUME_GUEST_WHEN_UNKNOWN) {
      // Tespit edemedik ama guest varsaymak istemiyoruz -> serbest bırak
      return;
    }

    // Guest (veya unknown -> guest)
    evt.preventDefault();
    evt.stopImmediatePropagation();

    saveEmailForAfterLogin(buttonEl);

    showWarning(WARNING_MESSAGE);
    window.location.assign(getLoginUrl());
  }

  // Click ile tetiklenen senaryo (butona tıklama)
  document.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || typeof target.closest !== 'function') return;

      var btn = target.closest(SELECTOR_NOTIFY_BUTTON);
      if (!btn) return;

      gateToLoginIfGuest(btn, evt);
    },
    true // capture: Halo'nun handler'ından önce yakalamak için
  );

  // Enter ile form submit senaryosu
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || form.tagName !== 'FORM') return;

      var btn = form.querySelector(SELECTOR_NOTIFY_BUTTON);
      if (!btn) return;

      gateToLoginIfGuest(btn, evt);
    },
    true
  );
})();
